export { default as ic_star } from "./ic_star.svg?react";
export { default as ic_notebook } from "./ic_notebook.svg?react";
export { default as ic_notebook_open } from "./ic_notebook_open.svg?react";
export { default as ic_expand } from "./ic_expand.svg?react";
export { default as ic_shrink } from "./ic_shrink.svg?react";
export { default as ic_close } from "./ic_close.svg?react";
export { default as ic_star_with_cirecle } from "./ic_star_with_cirecle.svg?react";
